const invoices = {
	buttons: {
		update_concept_invoices: "Conceptfacturen bijwerken",
	},
	overview: "Facturen overzicht",
	payment_status: {
		credit: "Credit",
		expired: "Vervallen",
		outstanding: "Openstaand",
		paid: "Betaald",
		partly_paid: "Deels betaald",
	},
	status_invoices_update_success: "Conceptfacturen succesvol bijgewerkt",
	status_invoices_update_unknown: "Er is wat mis gegaan bij het updaten van Conceptfacturen",
	table: {
		amount: "Bedrag",
		company_name: "Bedrijf",
		date: "Datum",
		debtor_code: "Debiteurcode",
		id: "Factuurnr.",
		status: "Status",
	},
	title: "Facturen",
	update_invoices_dialog: {
		description: "Wilt u de conceptfacturen bijwerken?",
		title: "Conceptfacturen bijwerken",
		update: "Bijwerken",
	},
};

export default invoices;
